<app-elynk-packet-select #packetSelect [active]="active" [documentTypeId]="documentTypeId"></app-elynk-packet-select>
<p-tabView styleClass="tw-mt-[3rem]">
    <p-tabPanel [disabled]="packetSelect.selectedPacket?.checklist===null || !active ">
        <ng-template pTemplate="header">
            <section class="header-title">
                <span class="vertical-align-middle"><strong>Checklist{{ ( packetSelect.selectedPacket?.id ? ' - ' + packetSelect.selectedPacket?.id : '') }}</strong></span>
            </section>
        </ng-template>
        <app-elynk-packet-checklist *ngIf="packetSelect.selectedPacket?.checklist != null && active "
            [documentTypeId]="documentTypeId" [(selectedPacket)]="packetSelect.selectedPacket">
        </app-elynk-packet-checklist>
    </p-tabPanel>

    <p-tabPanel [disabled]="packetSelect.selectedPacket?.add === null || ! active">
        <ng-template pTemplate="header">
            <section class="header-title">
                <span class="vertical-align-middle"><strong>Add{{ ( packetSelect.selectedPacket?.id ? ' - ' + packetSelect.selectedPacket?.id : '') }}</strong></span>
            </section>
        </ng-template>

        <app-elynk-packet-add  *ngIf="packetSelect.selectedPacket?.add !=null && active "
            [documentTypeId]="documentTypeId" [selectedPacket]="packetSelect.selectedPacket">
        </app-elynk-packet-add>
    </p-tabPanel>
</p-tabView>
